import React, { useEffect, useState } from 'react';
import { formatLiveCountdown, getEventSessionStart, type EventModel } from '../store/eventStore';

type Props = {
    /** Direkter Start (ms) — z. B. aus PopupCandidate */
    startsAtMs?: number | null;
    /** Oder Event-Modell (Morgensession) */
    event?: Pick<EventModel, 'baseDate' | 'overrideDate' | 'timeMorning' | 'timeEvening' | 'hasDoubleSession'> | null;
    className?: string;
};

/**
 * PEBase-Parität: roter Live-Badge, minutengenau, jede Minute aktualisiert.
 */
const EventLiveCountdownBadge: React.FC<Props> = ({ startsAtMs, event, className = '' }) => {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        // Sofort + jede volle Minute neu berechnen (minutengenau)
        const tick = () => setNow(Date.now());
        tick();
        const id = window.setInterval(tick, 15_000);
        return () => window.clearInterval(id);
    }, []);

    const start =
        typeof startsAtMs === 'number' && Number.isFinite(startsAtMs)
            ? new Date(startsAtMs)
            : event
              ? getEventSessionStart(event as EventModel, false)
              : null;

    const info = formatLiveCountdown(start, new Date(now));
    if (!info || info.kind === 'ended') return null;

    const tone =
        info.kind === 'live'
            ? 'bg-red-600 text-white border-red-400 shadow-[0_0_20px_rgba(220,38,38,0.55)] animate-pulse'
            : 'bg-red-600 text-white border-red-500/80 shadow-[0_0_16px_rgba(220,38,38,0.45)]';

    return (
        <span
            className={`inline-flex items-center px-3 py-1.5 rounded-lg text-[10px] sm:text-[11px] font-black uppercase tracking-widest border ${tone} ${className}`}
            aria-live="polite"
        >
            {info.label}
        </span>
    );
};

export default EventLiveCountdownBadge;
